import { cn } from "@d12labs/utils";
import { ArrowDown, ArrowRight, ArrowUp } from "lucide-react";

/** A signed change with a directional arrow and score-semantic color (up = better). */
export function Delta({ value, suffix = "" }: { value: number; suffix?: string }) {
	const rounded = Math.round(value * 10) / 10;
	const Icon = rounded > 0 ? ArrowUp : rounded < 0 ? ArrowDown : ArrowRight;
	const color =
		rounded > 0 ? "text-semantic-success" : rounded < 0 ? "text-chart-3" : "text-muted-foreground";
	return (
		<span className={cn("inline-flex items-center gap-0.5 tabular-nums", color)}>
			<Icon className="h-3 w-3" strokeWidth={2.5} />
			<span className="font-medium">
				{rounded > 0 ? "+" : ""}
				{rounded}
				{suffix}
			</span>
		</span>
	);
}
